export interface IUpdateLabDataRequest {
    id: number,
    hasFrozenScreening: boolean,
    hasFrozenExploratory: boolean,
    xmVirtualOption: number,
    labLavender40: number,
    labLavender70: number,
    labLavender85: number,
    labLavender100: number,
    // labPink40: number,
    labPink60: number,
    labPink100: number,
    // labPurple100: number,
    labRed100: number,
    labRed70: number,
    labYellow85: number,
    // labYellow90: number,
    // labYellow100: number,
    labGreen100: number,
    transLavender40: number,
    transLavender70: number,
    transLavender85: number,
    transLavender100: number,
    // transPink40: number,
    transPink60: number,
    transPink100: number,
    // transPurple100: number,
    transRed100: number,
    transRed70: number,
    transYellow85: number,
    // transYellow90: number,
    // transYellow100: number,
    transGreen100: number
}